import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const HomeBranch: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width="26.000000pt"
            height="24.000000pt"
            viewBox="0 0 26.000000 24.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)" fill="#c71e1e" stroke="none">
                <path d="M61 170 c-54 -50 -62 -61 -51 -74 7 -9 16 -13 21 -10 5 3 9 -13 9 -35 l0 -41 90 0 90 0 0 41 c0 22 4 38 9 35 5 -3 14 0 20 8 8 10 6 17 -9 31 -11 10 -20 31 -20 47 0 18 -5 28 -15 28 -8 0 -15 -5 -15 -12 0 -6 -13 0 -28 15 -15 15 -30 27 -33 27 -2 0 -33 -27 -68 -60z m106 -22 c27 -26 33 -39 33 -75 0 -36 -3 -43 -20 -43 -16 0 -20 7 -20 35 0 32 -2 35 -30 35 -28 0 -30 -3 -30 -35 0 -28 -4 -35 -20 -35 -17 0 -20 7 -20 42 0 34 6 49 32 75 18 18 34 33 37 33 3 0 20 -14 38 -32z" />
            </g>
        </svg>
    );
};

export default React.memo(HomeBranch);
